import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { AlmConfigurationRouter } from './alm-configuration.router';
import { reducers } from './state/alm-configuration.selectors';

@NgModule({
  imports: [
    AlmConfigurationRouter,
    StoreModule.forFeature('almConfiguration', reducers),
  ],
  declarations: []
})
export class AlmConfigurationScreenModule { }